import { useEffect } from 'react';

const SITE_TITLE = 'brianna.dk';

/**
 * Set document title and meta description for the current page. Call once per page.
 * Restores default title/description on unmount.
 */
export function usePageMeta(title: string, description?: string) {
  useEffect(() => {
    const fullTitle = title.includes(SITE_TITLE) ? title : `${title} | ${SITE_TITLE}`;
    const prevTitle = document.title;
    document.title = fullTitle;

    let prevDescription: string | null = null;
    const metaDesc = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (metaDesc) {
      prevDescription = metaDesc.getAttribute('content');
      if (description) metaDesc.setAttribute('content', description);
    }

    const ogTitle = document.querySelector<HTMLMetaElement>('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', fullTitle);
    const ogDesc = document.querySelector<HTMLMetaElement>('meta[property="og:description"]');
    if (ogDesc && description) ogDesc.setAttribute('content', description);
    const twTitle = document.querySelector<HTMLMetaElement>('meta[name="twitter:title"]');
    if (twTitle) twTitle.setAttribute('content', fullTitle);
    const twDesc = document.querySelector<HTMLMetaElement>('meta[name="twitter:description"]');
    if (twDesc && description) twDesc.setAttribute('content', description);

    return () => {
      document.title = prevTitle;
      if (metaDesc && prevDescription !== null) metaDesc.setAttribute('content', prevDescription);
      if (ogTitle) ogTitle.setAttribute('content', SITE_TITLE);
      if (ogDesc) ogDesc.setAttribute('content', 'Portfolio and self-made content on immigration and integration into Denmark.');
      if (twTitle) twTitle.setAttribute('content', SITE_TITLE);
      if (twDesc) twDesc.setAttribute('content', 'Portfolio and self-made content on immigration and integration into Denmark.');
    };
  }, [title, description]);
}
